module.exports = __webpack_public_path__ + "img/malla-main-2.02fff8fa.jpg";